export default __webpack_public_path__ + "static/media/wallet.35672567.svg";